import EllipsisOutlined from '@ant-design/icons/EllipsisOutlined'
import Toggle from 'components/Toggle'
import React, {cloneElement, useContext} from 'react'
import {NullAsDefault} from 'views/Shared'
import {LayoutContext} from '../../layouts/Default/LayoutContext'
import DrawerBottomDialog from "./DrawerBottomDialog";
import DrawerPopupDialog from "./DrawerPopupDialog";
import {useRequiredLogin} from "../../../views/Server/useRequiredLogin";


export const DrawDialog = ({
                               component = <EllipsisOutlined/>,
                               container = 'root',
                               isLoginRequired = false,
                               title,
                               children,
                               visible,
                               onCancel = NullAsDefault,
                               onClick = NullAsDefault,
                               width,
                               footer = false,
                               ...props
                           }) => {
    const {isSm, breakpoint} = useContext(LayoutContext)
    const isMob = !!isSm || (breakpoint === 'sm');
    const handleRequiredLogin = useRequiredLogin()

    return !!isMob ? (
        <Toggle defaultValue={visible}>
            {(isToggle, toggle) => (
                <>
                    {cloneElement(component, {
                        ...component.props,
                        onClick: !isLoginRequired
                            ? (value) => { toggle(value); onClick(value) }
                            : (value) => { handleRequiredLogin(() => { toggle(value); onClick(value) }) },
                    })}
                    {!!isToggle && (
                        <DrawerBottomDialog
                            isToggle={isToggle}
                            toggle={(value) => {
                                toggle(() => { onCancel(); return value })
                            }}
                            component={component}
                            {...props}>
                            {children}
                        </DrawerBottomDialog>
                    )}
                </>
            )}
        </Toggle>
    ) : (
        <Toggle defaultValue={visible}>
            {(isToggle, toggle) => (
                <>
                    {cloneElement(component, {
                        ...component.props,
                        onClick: !isLoginRequired
                            ? (value) => { toggle(value); onClick(value) }
                            : (value) => { handleRequiredLogin(() => { toggle(value); onClick(value) }) },
                    })}
                    <DrawerPopupDialog
                        width={width}
                        title={title}
                        open={isToggle}
                        setVisible={(value) => { toggle(value); onClick(value); if (!value) onCancel() }}
                        className="p-0"
                        component={component}
                        footer={footer}
                        {...props}>
                        {children}
                    </DrawerPopupDialog>
                </>
            )}
        </Toggle>
    )
}

export default DrawDialog